import { render, staticRenderFns } from "./superadmin.vue?vue&type=template&id=fbd189da&"
import script from "./superadmin.vue?vue&type=script&lang=js&"
export * from "./superadmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports